<div class="container-fluid">
    <div class="row">
        <app-section-title title="TITLES.LATEST-MEASUREMENTS">
        </app-section-title>
    </div>

    <div class="tablaLatestMeasurements">
        <div class="example-container mat-elevation-z8">
            <table mat-table [dataSource]="dataSource" matSort>

                <ng-container matColumnDef="dispositivo" sticky>
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'LATEST-MEASUREMENTS.DISPOSITIVO' | translate}}</th>
                    <td mat-cell *matCellDef="let element" class="dispositivosTablaMediciones"> {{element.dispositivo}} </td>
                </ng-container>

                <ng-container matColumnDef="contadorAgua">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'LATEST-MEASUREMENTS.CONTADOR-AGUA' | translate}}</th>
                    <td mat-cell *matCellDef="let element"> {{element.contadorAgua}} </td>
                </ng-container>

                <ng-container matColumnDef="contadorAireComprimido">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'LATEST-MEASUREMENTS.CONTADOR-AIRE-COMPRIMIDO' | translate}}</th>
                    <td mat-cell *matCellDef="let element"> {{element.contadorAireComprimido}} </td>
                </ng-container>

                <ng-container matColumnDef="contadorDesmoldeante">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'LATEST-MEASUREMENTS.CONTADOR-DESMOLDEANTE' | translate}}</th>
                    <td mat-cell *matCellDef="let element"> {{element.contadorDesmoldeante}} </td>
                </ng-container>

                <ng-container matColumnDef="contadorGas">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'LATEST-MEASUREMENTS.CONTADOR-GAS' | translate}}</th>
                    <td mat-cell *matCellDef="let element"> {{element.contadorGas}} </td>
                </ng-container>

                <ng-container matColumnDef="estado">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'LATEST-MEASUREMENTS.ESTADO' | translate}}</th>
                    <td mat-cell *matCellDef="let element"> {{element.estado}} </td>
                </ng-container>

                <ng-container matColumnDef="energiaActiva">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'LATEST-MEASUREMENTS.ENERGIA-ACTIVA' | translate}}</th>
                    <td mat-cell *matCellDef="let element"> {{element.energiaActiva}} </td>
                </ng-container>

                <ng-container matColumnDef="energiaReactiva">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'LATEST-MEASUREMENTS.ENERGIA-REACTIVA' | translate}}</th>
                    <td mat-cell *matCellDef="let element"> {{element.energiaReactiva}} </td>
                </ng-container>

                <ng-container matColumnDef="factorPotencia">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'LATEST-MEASUREMENTS.FACTOR-POTENCIA' | translate}}</th>
                    <td mat-cell *matCellDef="let element"> {{element.factorPotencia}} </td>
                </ng-container>

                <ng-container matColumnDef="intensidadLinea1">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'LATEST-MEASUREMENTS.INTENSIDAD-LINEA1' | translate}}</th>
                    <td mat-cell *matCellDef="let element"> {{element.intensidadLinea1}} </td>
                </ng-container>

                <ng-container matColumnDef="intensidadLinea2">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'LATEST-MEASUREMENTS.INTENSIDAD-LINEA2' | translate}}</th>
                    <td mat-cell *matCellDef="let element"> {{element.intensidadLinea2}} </td>
                </ng-container>

                <ng-container matColumnDef="intensidadLinea3">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'LATEST-MEASUREMENTS.INTENSIDAD-LINEA3' | translate}}</th>
                    <td mat-cell *matCellDef="let element"> {{element.intensidadLinea3}} </td>
                </ng-container>

                <ng-container matColumnDef="pesoBruto">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'LATEST-MEASUREMENTS.PESO-BRUTO' | translate}}</th>
                    <td mat-cell *matCellDef="let element"> {{element.pesoBruto}} </td>
                </ng-container>

                <ng-container matColumnDef="pesoNeto">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'LATEST-MEASUREMENTS.PESO-NETO' | translate}}</th>
                    <td mat-cell *matCellDef="let element"> {{element.pesoNeto}} </td>
                </ng-container>

                <ng-container matColumnDef="piezaBuena">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'LATEST-MEASUREMENTS.PIEZA-BUENA' | translate}}</th>
                    <td mat-cell *matCellDef="let element"> {{element.piezaBuena}} </td>
                </ng-container>

                <ng-container matColumnDef="piezaMala">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'LATEST-MEASUREMENTS.PIEZA-MALA' | translate}}</th>
                    <td mat-cell *matCellDef="let element"> {{element.piezaMala}} </td>
                </ng-container>

                <ng-container matColumnDef="potenciaActiva">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'LATEST-MEASUREMENTS.POTENCIA-ACTIVA' | translate}}</th>
                    <td mat-cell *matCellDef="let element"> {{element.potenciaActiva}} </td>
                </ng-container>

                <ng-container matColumnDef="potenciaReactiva">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'LATEST-MEASUREMENTS.POTENCIA-REACTIVA' | translate}}</th>
                    <td mat-cell *matCellDef="let element"> {{element.potenciaReactiva}} </td>
                </ng-container>

                <ng-container matColumnDef="referenciaPieza">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'LATEST-MEASUREMENTS.REFERENCIA-PIEZA' | translate}}</th>
                    <td mat-cell *matCellDef="let element"> {{element.referenciaPieza}} </td>
                </ng-container>

                <ng-container matColumnDef="tensionLinea1">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'LATEST-MEASUREMENTS.TENSION-LINEA1' | translate}}</th>
                    <td mat-cell *matCellDef="let element"> {{element.tensionLinea1}} </td>
                </ng-container>

                <ng-container matColumnDef="tensionLinea2">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'LATEST-MEASUREMENTS.TENSION-LINEA2' | translate}}</th>
                    <td mat-cell *matCellDef="let element"> {{element.tensionLinea2}} </td>
                </ng-container>

                <ng-container matColumnDef="tensionLinea3">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'LATEST-MEASUREMENTS.TENSION-LINEA3' | translate}}</th>
                        <td mat-cell *matCellDef="let element"> {{element.tensionLinea3}} </td>
                </ng-container>

                <ng-container matColumnDef="tiempoCiclo">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'LATEST-MEASUREMENTS.TIEMPO-CICLO' | translate}}</th>
                    <td mat-cell *matCellDef="let element"> {{element.tiempoCiclo}} </td>
                </ng-container>

                <ng-container matColumnDef="totalPiezas">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'LATEST-MEASUREMENTS.TOTAL-PIEZAS' | translate}}</th>
                    <td mat-cell *matCellDef="let element"> {{element.totalPiezas}} </td>
                </ng-container>

                <ng-container matColumnDef="totalPiezasCorrectas">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'LATEST-MEASUREMENTS.TOTAL-PIEZAS-CORRECTAS' | translate}}</th>
                    <td mat-cell *matCellDef="let element"> {{element.totalPiezasCorrectas}} </td>
                </ng-container>

                <ng-container matColumnDef="unidades">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'LATEST-MEASUREMENTS.UNIDADES' | translate}}</th>
                        <td mat-cell *matCellDef="let element"> {{element.unidades}} </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
        </div>
        <mat-paginator [pageSizeOptions]="[10, 20, 30]" showFirstLastButtons></mat-paginator>
    </div>

</div>